import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const AnguillaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14278'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14278)'>
				<rect
					width='20'
					height='14'
					fill='#0A17A7'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.3809 6.99996C12.3809 5.59996 12.3809 4.66663 12.3809 4.66663L13.3332 5.13329L14.2856 4.66663L15.238 5.13329L16.1904 4.66663C16.1904 4.66663 16.1904 5.59996 16.1904 6.99996C16.1904 8.39996 14.2856 9.33329 14.2856 9.33329C14.2856 9.33329 12.3809 8.39996 12.3809 6.99996Z'
					fill='white'
				/>
				<mask
					id='mask1_2332_14278'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='12'
					y='4'
					width='5'
					height='6'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M12.3809 6.99996C12.3809 5.59996 12.3809 4.66663 12.3809 4.66663L13.3332 5.13329L14.2856 4.66663L15.238 5.13329L16.1904 4.66663C16.1904 4.66663 16.1904 5.59996 16.1904 6.99996C16.1904 8.39996 14.2856 9.33329 14.2856 9.33329C14.2856 9.33329 12.3809 8.39996 12.3809 6.99996Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_14278)'>
					<rect
						x='12.3809'
						y='8.3999'
						width='3.80952'
						height='0.933333'
						fill='#9ACCFF'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M14.286 6.53331C14.549 6.53331 14.7622 6.32438 14.7622 6.06664C14.7622 5.80891 14.549 5.59998 14.286 5.59998C14.023 5.59998 13.8098 5.80891 13.8098 6.06664C13.8098 6.32438 14.023 6.53331 14.286 6.53331ZM13.3336 7.46664C13.5966 7.46664 13.8098 7.25771 13.8098 6.99998C13.8098 6.74224 13.5966 6.53331 13.3336 6.53331C13.0706 6.53331 12.8574 6.74224 12.8574 6.99998C12.8574 7.25771 13.0706 7.46664 13.3336 7.46664ZM15.7146 6.99998C15.7146 7.25771 15.5014 7.46664 15.2384 7.46664C14.9754 7.46664 14.7622 7.25771 14.7622 6.99998C14.7622 6.74224 14.9754 6.53331 15.2384 6.53331C15.5014 6.53331 15.7146 6.74224 15.7146 6.99998Z'
						fill='url(#paint0_linear_2332_14278)'
					/>
				</g>
				<path
					d='M-0.915074 -0.333333H0H0.47619H0.581265L0.667345 -0.273077L3.9146 2H4.66793L8.39732 -0.284251L8.90476 -0.595057V0V0.293115C8.90476 0.510658 8.79862 0.714517 8.6204 0.839269L5.57143 2.97355V3.578L8.45876 6.00336C8.80818 6.29688 8.60063 6.86667 8.14428 6.86667C8.04397 6.86667 7.94608 6.83581 7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828M-0.915074 -0.333333L-0.214397 0.255235L3 2.95533V3.55978L-0.191154 5.79359L-0.333333 5.89311V6.06667V6.53333V7.12839L0.174104 6.81758L3.90349 4.53333H4.65683L7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828'
					fill='#FF2E3B'
					stroke='white'
					strokeWidth='0.666667'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.33333V4.2H3.33333V6.33333C3.33333 6.70152 3.63181 7 4 7H4.57143C4.93962 7 5.23809 6.70152 5.23809 6.33333V4.2H8.38095C8.74914 4.2 9.04762 3.90152 9.04762 3.53333V3C9.04762 2.63181 8.74914 2.33333 8.38095 2.33333H5.23809V0H3.33333V2.33333H0Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H3.80952V2.33333V0H4.7619V2.33333V2.8H8.57143V3.73333H4.7619V4.2V6.53333H3.80952V4.2V3.73333H0V2.8Z'
					fill='#FF2E3B'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_14278'
					x1='12.8574'
					y1='5.59998'
					x2='12.8574'
					y2='7.46664'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FFA51B' />
					<stop
						offset='1'
						stopColor='#FF9A00'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default AnguillaFlagIcon;
